import { render, staticRenderFns } from "./CockpitLineVerticalSelector.vue?vue&type=template&id=67ef848f&scoped=true"
import script from "./CockpitLineVerticalSelector.vue?vue&type=script&lang=js"
export * from "./CockpitLineVerticalSelector.vue?vue&type=script&lang=js"
import style0 from "./CockpitLineVerticalSelector.vue?vue&type=style&index=0&id=67ef848f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ef848f",
  null
  
)

export default component.exports